import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-error-layout',
  templateUrl: './error-layout.html',
  styleUrl: './error-layout.scss',
  imports: [
    RouterOutlet
  ]
})
export class ErrorLayoutComponent {

}
